import {
  BlockHtmlAdapterExtension,
  BlockMarkdownAdapterExtension,
  BlockPlainTextAdapterExtension,
} from '@blocksuite/affine-shared/adapters';

// Markdown and plain text have no column layout: export every child in reading
// order. AFFiNE's native snapshot/clipboard format preserves the containers.
export const ColumnAdapterExtensions = [
  'affine:column-row',
  'affine:column',
].flatMap(flavour => {
  const matcher = {
    flavour,
    toMatch: () => false,
    fromMatch: (o: { node: { flavour: string } }) => o.node.flavour === flavour,
    toBlockSnapshot: {},
    fromBlockSnapshot: {},
  };
  return [
    BlockHtmlAdapterExtension(matcher),
    BlockMarkdownAdapterExtension(matcher),
    BlockPlainTextAdapterExtension(matcher),
  ];
});
